export enum NivelSni {
  NO_APROBADO = 'N',
  CANDIDATO = 'C',
  NIVEL_I = '1',
  NIVEL_II = '2',
  NIVEL_III = '3',
  NIVEL_EMERITO = 'E',
}

export interface INivelSniSelect {
  value: NivelSni;
  text: string;
}

export default function obtenerNivelesSni(): INivelSniSelect[] {
  return [
    { value: NivelSni.NO_APROBADO, text: 'No Aprobado' },
    { value: NivelSni.CANDIDATO, text: 'Candidato' },
    { value: NivelSni.NIVEL_I, text: 'Nivel I' },
    { value: NivelSni.NIVEL_II, text: 'Nivel II' },
    { value: NivelSni.NIVEL_III, text: 'Nivel III' },
    { value: NivelSni.NIVEL_EMERITO, text: 'Nivel Emérito' },
  ];
}
